import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-data-call-intercepter',
	templateUrl:'./DataCallIntercepterPluginCompPage.html',
	styles: [],
	styleUrls:['./DataCallIntercepterPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DataCallIntercepterPluginCompPage
{
	mdContent_883 = `\`\`\`java
import com.jwebmp.client.DataCallIntercepter;
\`\`\``;
	mdContent_884 = `\`\`\`java
public class CacheInterceptor implements DataCallIntercepter&lt;CacheInterceptor&gt; {
    @Override
    public void intercept(AjaxCall&lt;?&gt; call, AjaxResponse&lt;?&gt; response) {
        // Add cache control logic
    }
}
\`\`\``;
}
